import React from "react";
import {
    FaLinkedinIn,
    FaGithub,
    FaWhatsapp,
    FaMapMarkerAlt,
    FaPhoneAlt,
    FaEnvelope,
    FaGlobe,
} from "react-icons/fa";
import { contactImg } from "../../assets/index";

const ContactLeft = () => {
    return (
        <div className="w-full lgl:w-[35%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-4 lgl:p-8 rounded-lg shadow-shadowOne flex flex-col gap-8 justify-center">
            <img
                className="w-full h-64 object-cover rounded-lg mb-2"
                src={contactImg}
                alt="César Agudelo"
            />

            <div className="flex flex-col gap-4">
                <h3 className="text-3xl font-bold text-white">César Agudelo</h3>

                <p className="text-lg font-normal text-gray-400">
                    QA Automation Engineer
                </p>

                {/* Availability */}
                <p className="text-sm text-designColor flex items-center gap-2 tracking-wide">
                    <FaGlobe />
                    Available for remote work
                </p>

                {/* Justified description */}
                <p className="text-base text-gray-400 tracking-wide text-justify">
                    Feel free to reach out for collaboration, consulting, or opportunities
                    in QA automation and testing.
                </p>

                <p className="text-base text-gray-400 flex items-center gap-3">
                    <FaMapMarkerAlt className="text-designColor" />
                    <span className="text-lightText">Colombia</span>
                </p>

                <p className="text-base text-gray-400 flex items-center gap-3">
                    <FaPhoneAlt className="text-designColor" />
                    <span className="text-lightText">+57 3127555467</span>
                </p>

                <p className="text-base text-gray-400 flex items-center gap-3">
                    <FaEnvelope className="text-designColor" />
                    <span className="text-lightText">info@cesaragudelo.com</span>
                </p>
            </div>

            <div className="flex flex-col gap-4">
                <h2 className="text-base uppercase font-titleFont mb-4">
                    Find me on
                </h2>
                <div className="flex gap-4">
                    <a
                        className="bannerIcon"
                        href="https://www.linkedin.com/in/cesar-agudelo/"
                        target="_blank"
                        rel="noreferrer"
                        aria-label="LinkedIn"
                    >
                        <FaLinkedinIn />
                    </a>

                    <a
                        className="bannerIcon"
                        href="https://wa.me/573127555467"
                        target="_blank"
                        rel="noreferrer"
                        aria-label="WhatsApp"
                    >
                        <FaWhatsapp />
                    </a>

                    <a
                        className="bannerIcon"
                        href="https://github.com/cesaragudeloh"
                        target="_blank"
                        rel="noreferrer"
                        aria-label="GitHub"
                    >
                        <FaGithub />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default ContactLeft;
